export const ALL_ITEM_LABEL = "All";
